module.exports = __webpack_public_path__ + "img/1. ULTRA, CASE AND ACCESSORIES.png";